import Node from '@/common/models/node.model';
import ROLES from '@/common/constants/roles.constants';
import i18n from '@/common/i18n';
import { uniq } from 'lodash-es';
import getSubnetCidr from '@/common/utils/getSubnetCidr';

function getIp(ip) {
  return ip.substring(0, ip.lastIndexOf('/'));
}

export default {
  getItemsFromLocations: (state, getters, rootState, rootGetters) => rootGetters['locations/allNodes'],
  isLoading: (state, getters, rootState, rootGetters) => rootGetters['locations/isLoading'],
  getItems: (state, getters) => getters.getItemsFromLocations.map(node => new Node(node)),
  getItemById: (state, getters) => id => {
    const node = getters.getItemsFromLocations.find(it => it.id === id);
    return node ? new Node(node) : undefined;
  },
  getItemsByIds: (state, getters) => ids => getters.getItemsFromLocations
    .reduce((acc, node) => ids.includes(node.id) ? { ...acc, [node.id]: node } : acc, {}),
  getPrimaryNode: (state, getters) => getters.getItemsFromLocations.find(node => node.isPrimary),
  getManagementNodes: (state, getters) => getters.getItems.filter(node => node.isManagement),
  haNodes: (state, getters) => getters.getItems.filter(node => node.isInHA),
  roles: () => ({
    cses: i18n.t('CSes'),
    iscsi: i18n.t('ISCSI'),
    management: i18n.t('Management'),
    mdses: i18n.t('MDSes'),
    s3: i18n.t('S3'),
    nfs: i18n.t('NFS'),
    abgw: i18n.t('ABGW'),
  }),
  getNodeInterfaces: (state, getters, rootState, rootGetters) => id => rootGetters['nodesInterfaces/getInterfaces'](id),
  getAllNodesInterfaces: (state, getters, rootState, rootGetters) => rootGetters['nodesInterfaces/getInterfacesList'],
  getNodeStorageInterface: (state, getters, rootState, rootGetters) => id => {
    const ifs = getters.getNodeInterfaces(id);
    return ifs.find((ifc) => rootGetters['rolesets/isSetWithStorage'](ifc.roles_set));
  },
  getNodeNetworks: (state, getters, rootState, rootGetters) => {
    const nodes = getters.getItems;
    const rolesets = rootGetters['rolesets/rolesets'];
    return rolesets.map(({ id, name, roles }) => {
      const cidrs = nodes.map(node => getSubnetCidr(node.networks.find(iface => iface.roles_set === id)?.ipv4)).flat();
      return {
        name,
        roles,
        roleset: id,
        cidrs: uniq(cidrs)
      };
    });
  },
  nodesInterfacesPending: (state, getters, rootState, rootGetters) => id => rootGetters['nodesInterfaces/getPending'](id),
  isAnyInterfacePending: (state, getters, rootState, rootGetters) => rootGetters['nodesInterfaces/isAnyPending'],
  getNodeInterfaceByName: (state, getters) => (id, ifsName) => {
    const nodeIfs = getters.getNodeInterfaces(id);
    if (!nodeIfs || !(nodeIfs instanceof Array)) {
      return null;
    }
    return nodeIfs.find(ifs => ifs.name === ifsName);
  },
  getNodeTargets: (_state, getters, _mainState, rootGetters) => getters.getItems?.filter(it => it.isAssigned).map((it) => {
    const addresses = [];
    const targetNames = rootGetters['iscsi/targets/getItemsByNodeId'](it.id).map(target => target.name);

    getters.getNodeInterfaces(it.id).forEach(function (iface) {
      const roleSet = rootGetters['rolesets/rolesets'].find(rs => iface.roles_set === rs.id);

      if (roleSet?.roles.includes(ROLES.ISCSI)) {
        iface.ipv4.map(getIp).forEach(function (ip) {
          addresses.push({
            name: iface.name,
            ip,
            checked: false
          });
        });
      }
    });

    return {
      id: it.id,
      name: it.name,
      targetNames,
      addresses
    };
  }),
};
